var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',[_c('wizard',{attrs:{"title":_vm.title,"steps":_vm.steps},on:{"changeStep":_vm.changeStep}},[_c('router-view',{on:{"nextStep":_vm.nextStep,"previousStep":_vm.previousStep}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }